export type ArrayLike<T> = {
	length: number;
	[i: number]: T;
};

export function count<T>(collection: ArrayLike<T>, filter: (item: T) => boolean): number {
	let matchCount = 0;

	for (let i = 0; i < collection.length; i++) {
		if (filter(collection[ i ])) {
			matchCount++;
		}
	}

	return matchCount;
}

export function take<T>(collection: Array<T>, quantity = 1): Array<T> {
	return [ ...collection ].splice(0, quantity);
}

export function takeRight<T>(collection: Array<T>, quantity = 1): Array<T> {
	return [ ...collection ].splice(-quantity, quantity);
}

export function takeRandom<T>(collection: Array<T>): T {
	return collection[ Math.floor(Math.random() * collection.length) ];
}

export function updateAt<T>(collection: Array<T>, index: number, handler: (entry: T) => T): Array<T> {
	const target = collection[ index ];

	if (!target) {
		return collection;
	}

	return [ ...collection.slice(0, index), handler(target), ...collection.slice(index + 1) ];
}

export function arrayify<T>(value: T | Array<T> | undefined): Array<T> {
	if (Array.isArray(value)) {
		return value;
	}

	return value ? [ value ] : [];
}
